var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWinfieldsChocolateBarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 581.941,
    height: 151.493,
    viewBox: "0 0 581.941 151.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 581.941,
    height: 151.493,
    fill: "#003f43"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M99.032,0h28.175l-13.4,14.5L96.161,85.49V95.749H80.292v-.137l-13-49.653C48.557,54.713,41.583,65.244,46.507,85.352l.137.137V95.749H30.777L7.66,8.207,0,0H33.786l-7.66,8.207,17.78,67.023C43.5,58,55.26,50.2,67.025,44.864L57.449,8.207,49.926,0H83.573l-7.8,8.617,7.8,29.408c12.721-4.924,24.349-10.259,28.315-21.338l.549-1.915ZM95.476,82.753l15.181-60.868c-5.471,8.48-16.277,13.131-26.809,17.372Z",
    transform: "translate(0 -0.001)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M307.18,9.438c0,6.565-4.651,15.045-12.585,16.687l-.135-.82c4.376-1.367,7.385-5.608,6.84-11.081-5.745,1.232-9.439-2.462-9.439-6.838A7.355,7.355,0,0,1,299.247,0c4.1,0,7.933,2.872,7.933,9.437",
    transform: "translate(221.726 0)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M353.617,64.241c0,11.9-11.216,19.7-23.937,19.7H303.691l-2.325-22.433L324.482,82.3a30.912,30.912,0,0,0,5.2.41c7.8,0,14.225-3.009,14.225-7.934,0-7.523-13.678-13.268-22.433-18.192l-6.428-3.556c-8.617-4.788-14.5-11.626-14.5-19.7,0-10.944,9.986-17.782,21.475-17.782h24.074l2.735,21.338L328.039,17.324a33.573,33.573,0,0,0-6.018-.547c-5.335,0-12.584,1.369-12.584,6.565,0,6.43,7.248,10.259,17.645,15.732l8.345,4.376c9.847,5.2,18.192,12.448,18.192,20.791",
    transform: "translate(228.324 11.81)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M78.177,75.594V28.677l-7.385-4.924,25.167-8.207V75.594l7.387,8.343H70.791Z",
    transform: "translate(53.78 11.81)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M157.646,75.771l7.385,8.343H132.477l7.387-8.343V35.009c0-6.975-5.471-12.446-11.489-12.446-3.7,0-7.525,1.777-10.806,5.334V75.771l7.385,8.343H92.4l7.385-8.343V29.948L92.4,25.025l25.169-9.3V26.255c6.975-7.113,14.635-10.942,21.885-10.942,10.806,0,18.192,8.617,18.192,19.559Z",
    transform: "translate(70.196 11.633)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M143.624,86.932V27.979h-6.293V26.885h6.293C144.172,9.238,157.44.621,176.314.621a51.167,51.167,0,0,1,16.142,2.464l-15.32,11.626c-4.1-8.482-6.428-11.491-9.849-11.491-6.018,0-5.881,7.113-5.881,13V26.885H188.49v1.095H161.406V86.932l7.386,8.343H136.239Z",
    transform: "translate(103.501 0.471)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M253.36,86.814l7.385,8.343H228.192l7.385-8.343V14.045L228.192,9.12,253.36.777Z",
    transform: "translate(173.358 0.59)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M276.323,26.082a24.525,24.525,0,0,1,19.424,8.89V14.044L288.36,9.121,313.529.778V86.815l7.385,8.343H295.747V86.95a24.628,24.628,0,0,1-19.424,8.892c-15.318,0-27.766-15.732-27.766-34.881s12.448-34.879,27.766-34.879M283.438,92.7c4.649,0,9.026-3.556,12.309-7.8V37.024c-3.284-4.239-7.66-7.8-12.309-7.8-10.534,0-16.962,17.37-16.962,31.733S272.9,92.7,283.438,92.7",
    transform: "translate(188.829 0.59)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M242.642,63.442c.135,4.862-.6,9.39-2.312,12.73-1.758,3.424-4.547,5.6-8.494,5.6-9.888,0-19.712-12.726-24.96-27.069a64.485,64.485,0,0,1-3.643-15.228,48.46,48.46,0,0,1,.014-8.038h49.243a34.993,34.993,0,0,0-64.56,18.6l0,0c0,.023,0,.046,0,.069s0,.046,0,.069a34.334,34.334,0,0,0,18.079,30.388c.083.044.162.092.245.137s.167.084.25.128a34.479,34.479,0,0,0,16.305,4.09c.128,0,.255-.007.382-.007a35.02,35.02,0,0,0,31.763-21.468Zm-26.4-45.823c7.113,0,13.268,5.608,15.457,12.721H203.384c.957-8.07,5.2-12.721,12.858-12.721",
    transform: "translate(142.77 11.515)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M174.949,75.594V28.677l-7.385-4.924,25.167-8.207V75.594l7.387,8.343H167.564Z",
    transform: "translate(127.298 11.81)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M170.828,10.122A10.122,10.122,0,1,1,180.95,20.244a10.1,10.1,0,0,1-10.122-10.122",
    transform: "translate(129.778 -0.001)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M74.056,10.122A10.122,10.122,0,1,1,84.178,20.244,10.1,10.1,0,0,1,74.056,10.122",
    transform: "translate(56.26 -0.001)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M66.335,70.358a9.682,9.682,0,0,1,9.944,7.709H74.088a7.74,7.74,0,0,0-7.753-5.606c-5.562,0-9.548,4.51-9.548,11.739,0,7.183,3.986,11.739,9.548,11.739a7.742,7.742,0,0,0,7.753-5.606h2.191a9.714,9.714,0,0,1-9.944,7.709c-6.613,0-11.827-5.344-11.827-13.842s5.214-13.842,11.827-13.842",
    transform: "translate(41.41 53.45)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M96.8,70.583v26.9H94.57V84.643H77.529V97.478H75.3v-26.9h2.233v12H94.57v-12Z",
    transform: "translate(57.202 53.621)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M107.8,98.042c-6.833,0-11.871-5.606-11.871-13.842s5.038-13.842,11.871-13.842c6.877,0,11.915,5.608,11.915,13.842S114.681,98.042,107.8,98.042m0-25.581c-5.694,0-9.592,4.818-9.592,11.739s3.9,11.741,9.592,11.741c5.738,0,9.638-4.82,9.638-11.741s-3.9-11.739-9.638-11.739",
    transform: "translate(72.88 53.45)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M128.8,70.358a9.682,9.682,0,0,1,9.944,7.709H136.55a7.74,7.74,0,0,0-7.753-5.606c-5.562,0-9.548,4.51-9.548,11.739,0,7.183,3.986,11.739,9.548,11.739a7.742,7.742,0,0,0,7.753-5.606h2.191a9.714,9.714,0,0,1-9.944,7.709c-6.613,0-11.827-5.344-11.827-13.842s5.214-13.842,11.827-13.842",
    transform: "translate(88.862 53.45)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M148.632,98.042c-6.833,0-11.871-5.606-11.871-13.842s5.038-13.842,11.871-13.842c6.877,0,11.915,5.608,11.915,13.842s-5.038,13.842-11.915,13.842m0-25.581c-5.694,0-9.592,4.818-9.592,11.739s3.9,11.741,9.592,11.741c5.738,0,9.638-4.82,9.638-11.741s-3.9-11.739-9.638-11.739",
    transform: "translate(103.897 53.45)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M158.668,70.583H160.9V95.419h14.588v2.059H158.668Z",
    transform: "translate(120.54 53.621)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M187.976,70.582l10.644,26.9h-2.235l-3.5-8.848H180.967l-3.46,8.848h-2.235l10.644-26.9Zm-6.221,16.033h10.338l-5.17-13.141Z",
    transform: "translate(133.155 53.62)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M194.144,70.583h21.9v2.059h-9.856V97.478h-2.233V72.641h-9.812Z",
    transform: "translate(147.491 53.621)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M231.5,70.583v2.059H217v9.942h13.14v2.059H217V95.419h14.5v2.059H214.807v-26.9Z",
    transform: "translate(163.188 53.621)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M262.906,90.074c0,4.73-3.284,7.4-8.76,7.4h-9.068v-26.9h8.235c5.52,0,8.586,2.5,8.586,6.965a5.84,5.84,0,0,1-4.424,6,6.43,6.43,0,0,1,5.43,6.527m-9.592-7.4c4.118,0,6.4-1.665,6.4-5.036s-2.279-5.038-6.4-5.038h-6.045V82.671Zm-6.045,12.791h7.009c4.2,0,6.395-2.147,6.395-5.432s-2.191-5.43-6.395-5.43h-7.009Z",
    transform: "translate(186.186 53.62)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M274.785,70.582l10.644,26.9h-2.235l-3.5-8.848H267.776l-3.46,8.848h-2.235l10.644-26.9Zm-6.221,16.033H278.9l-5.17-13.141Z",
    transform: "translate(199.103 53.62)",
    fill: "#003f43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M285.6,85.606V97.477h-2.233v-26.9h9.5c5.256,0,8.454,2.629,8.454,7.535,0,4.38-2.583,6.875-6.833,7.4l8.1,11.959h-2.583L292.04,85.606Zm0-1.971h7.183c4.118,0,6.353-2.059,6.353-5.518,0-3.549-2.235-5.52-6.353-5.52H285.6Z",
    transform: "translate(215.274 53.62)",
    fill: "#003f43"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinfieldsChocolateBarLogo);
export default __webpack_public_path__ + "static/media/WinfieldsChocolateBar_logo.5d372608e4c3f09e7b0dd2e08aeae87b.svg";
export { ForwardRef as ReactComponent };